import React, { useState, useEffect } from "react";
import "./PayBillsPage.scss";
import Hero from "../../common/Hero/Hero";
import { useTranslation } from "react-i18next";
import FiltersBox from "../../common/FiltersBox/FiltersBox";
import DataTable from "../../common/DataTable/DataTable";
import { Link } from "react-router-dom";
import NoResult from "../../common/NoResult/NoResult";
import { useDispatch, useSelector } from "react-redux";
import { convertTime, payBills } from "../../../helpers/helpers";
import { ManageContainerClass } from "../../../helpers/customHooks";
import { upaidBills } from "../../../reducers/contracts";

const PayBillsCta = ({ t, pay, selectedRows }) => {
  const totalToPay =
    selectedRows && selectedRows.length > 1
      ? selectedRows.reduce((total, curr, i) => {
        return isNaN(total) ? total.residualAmount + curr.residualAmount : total + curr.residualAmount;
      })
      : selectedRows[0].residualAmount;

  return (
    <div className="pay-bills-ctas">
      {/* <div className="inner-container d-flex"> */}
        {/* <div className="d-flex"> */}
          <div className="info">
            <p className="bills-text">
              {t("common.haveSelected")} {selectedRows && selectedRows.length}{" "}
              {selectedRows.length === 1
                ? t("bills.pay.bill")
                : t("bills.pay.bills")}
            </p>
             <p className="total-text">
              ({t("common.total")} {totalToPay.toFixed(2)} €)
            </p>
      </div>
        <button type="button" onClick={pay} className={"btn btn-primary btn-pay-bills"}>
          {t("common.payment")}
          <i className="gc-icon-functional-arrow-right" aria-hidden="true"/>
        </button>
    </div>
  );
};

const TableWrapper = ({
  columns,
  columnOrder,
  bills,
  genericError,
  t,
  payBills,
}) => {
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [width] = ManageContainerClass();
  const downloaderClass = width > 768 ? "container cta" : "cta";
  const handleGenericError = () => {
    return (
      <div className={"container"}>
        <div className={"row"}>
          <div className="col-sm-12 mt-5">
            <div className={"generic-error d-flex justify-content-start"}>
              <i
                className="gc-icon-functional-attention-1-col"
                aria-hidden="true"
              ></i>
              <p>{t(genericError)}</p>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleRowSelects = (rowsIds, rowsData) => {
    const previousRow = JSON.stringify(selectedRowsData);
    const addedRow = JSON.stringify(rowsData);
    if (previousRow !== addedRow) {
      setSelectedRowsData(rowsData);
    }
  };

  const renderCta = () => {
    return selectedRowsData.length ? (
      <PayBillsCta
        selectedRows={selectedRowsData}
        t={t}
        pay={() => payBills(selectedRowsData)}
      />
    ) : null;
  };

  return (
    <>
      <div className="container">
        <DataTable
          dtTable={[]}
          columns={columns}
          columnOrder={columnOrder}
          data={bills}
          selectedRowsIds={handleRowSelects}
        />
        {genericError && handleGenericError()}
      </div>
      <div className={downloaderClass}>{renderCta()}</div>
    </>
  );
};

const PayBillsPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [genericError, setGenericError] = useState(null);
  const [loaded, setLoaded] = useState(false);
  const current = useSelector((state) => state.contracts.current);
  const currentContract = current ? current.id : null;
  const bills = useSelector(upaidBills);
  const allBills =
    useSelector((state) => state.contracts.bills) ||
    null;
  const [filterMode, toggleFilterMode] = useState(false);
  const [filtredItems, setFiltredItems] = useState([]);
  const [filters, setFilters] = useState({});
  const filtersSettings = {
    fields: [
      {
        label: t("bills.filters.contract"),
        name: "contratto",
        type: "contractDropDown",
        leftIcon: "lens",
        columnSize: "8",
      },
      {
        label: t("bills.pay.filters.selectExpirtionDate"),
        name: "from",
        type: "date",
        columnSize: "4",
        placeholder: t('bills.datepicker.placeholder'),
      }
    ],
    validations: [],
    configuration: {
      hasReset: true,
    },
  };

  const [filterConfig] = useState(filtersSettings);

  const onFiltersChanged = (e) => {
    if (e.from) {
      setFilters(e);
    } else {
      setFilters({});
      toggleFilterMode(false);
      setFiltredItems([]);
    }
  };

  const convertToPrice = (value) => `€${Number(value).toFixed(2)}`;

  const orderColumns = ["test1", "test2", "test3"];

  const columns = React.useMemo(
    () => [
      {
        // Make an expander cell
        Header: ({ getToggleAllRowsSelectedProps }) => {
          const p = getToggleAllRowsSelectedProps();
          delete p.indeterminate;
          return (
            <>
              <div className="form-check abc-checkbox">
                <input
                  {...p}
                  className="form-check-input"
                  id="checkbox1"
                  type="checkbox"
                  aria-label={t("header.checkbox.label")}
                />
                <label
                  aria-hidden="true"
                  className="form-check-label"
                  htmlFor="checkbox1"
                ></label>
              </div>
              {/* <label className="container-checkbox">
              <input {...p} type="checkbox" name="checkbox" id="checkbox" />
              <span className="checkmark color-sky"></span>
            </label> */}
            </>
          );
        },
        id: "checkBox", // It needs an ID
        accessor: "expander",
        Cell: ({ row, getToggleAllRowsSelectedProps }) => {
          const p = row.getToggleRowSelectedProps();
          delete p.indeterminate;
          return (
            <>
              <div className="form-check abc-checkbox">
                <input
                  {...p}
                  type="checkbox"
                  name={`checkbox-${row.id}`}
                  id={`checkbox-${row.id}`}
                  aria-label={t("checkbox.label.invoiceNumber") + " " + row.original.invoiceNumber}
                />
                <label
                  className="form-check-label"
                  htmlFor={`checkbox-${row.id}`}
                ></label>
              </div>
            </>
          );
        },
      },

      {
        Header: t("bills.headers.invoiceNumber"),
        accessor: "invoiceNumber",
        id: 1,
      },
      {
        Header: t("bills.headers.issueDate"),
        accessor: "issueDate",
        id: 2,
        Cell: ({ row }) => convertTime(row.original.issueDate),
      },
      {
        Header: t("bills.headers.expirationDate"),
        accessor: "expirationDate",
        id: 3,
        Cell: ({ row }) => convertTime(row.original.expirationDate)
      },
      {
        Header: t("bills.headers.status"),
        accessor: "status",
        id: 4,
        Cell: ({ row }) => {
          if (!row.original.isPaid) {
            return (
              <p>
                {t("bills.status.not_paid")}
              </p>
            );
          } else {
            return <p>{t("bills.status.paid")}</p>;
          }
        },
      },
      {
        Header: t("bills.headers.amount"),
        accessor: "amount",
        id: 5,
        Cell: ({ row }) => {
          return convertToPrice(row.original.amount);
        },
      },
      {
        Header: t("bills.headers.residualAmount"),
        accessor: "residualAmount",
        id: 6,
        Cell: ({ row }) => {
          return row.original.residualAmount ? (
           <span>{convertToPrice(row.original.residualAmount)}</span>
          ) : (
            "-"
          );
        },
      },
    ],
    [t]
  );
  const handlePayBill = (bills) => {
    const billsToPaidAmount = bills.map((bill) => bill.amount);
    const startEventDataLayer = () => {
      let amount = 0;
      if (billsToPaidAmount) {
        billsToPaidAmount.forEach(bill => amount += bill);
        window.dataLayer.push({ "event": "pratica", "tipo": "pagamento", "step": "invio_richiesta", "esito": "OK", "quantità": billsToPaidAmount.length, "valore": amount })
      }
    };
    const startEventDataLayerKo = () => {
      let amount = 0;
      if (billsToPaidAmount) {
        billsToPaidAmount.forEach(bill => amount += bill);
        window.dataLayer.push({ "event": "pratica", "tipo": "pagamento", "step": "invio_richiesta", "esito": "KO", "quantità": bills.length, "valore": amount })
      }
    };
    const billsToPaid = {
      codIdContratto: currentContract,
      codIdBolletta: bills.map((bill) => bill.id),
      channel: "WEB",
    };
    payBills(billsToPaid, dispatch, setGenericError, bills, startEventDataLayer, startEventDataLayerKo);
  };
  useEffect(() => {
    if (filters && filters.from) {
      if (!filterMode) {
        toggleFilterMode(true);
      }
      setFiltredItems(bills.filter((bill) => {
        const itemDate = new Date(bill.expirationDate);
        const date = new Date(filters.from);

        return itemDate.getTime() === date.getTime();
      }));
    }
    // eslint-disable-next-line
  }, [bills, filters]);

  useEffect(() => {
    let timeout;
    if (bills) {
      timeout = setTimeout(() => setLoaded(true), 2000);
    }
    return () => {
      clearTimeout(timeout);
    };
    // eslint-disable-next-line
  }, [allBills]);

  const billsToRender = filterMode ? filtredItems : bills;

  return (
    <div className="PayBillsPage" data-testid="PayBillsPage">
      <Hero
        helpText={t("bills_pay.help")}
        backTo={"/"}
        backToText={t("common.back.home")}
        title={t("bills.pay.heroTitle")}
        description={t("bills.pay.heroDesc")}
      />
      <FiltersBox
        config={filterConfig}
        onChange={onFiltersChanged}
        data={bills}
        onDataFiltered={setFiltredItems}
        filter={(bills, filters) => {
          if (Object.keys(filters).length === 0) {
            return bills;
          }
          return bills.filter((bill) => {
            const itemDate = new Date(bill.expirationDate);
            const date = new Date(filters.from);

            return itemDate.getTime() === date.getTime();
          });
        }}
        checkContractStatus={true}
      />
      <div className="contracts-container-margin-top">
        {billsToRender && billsToRender.length > 0 ? (
          <>
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <p className="title">{current && current.name}</p>
                </div>
              </div>
            </div>
            <TableWrapper
              t={t}
              columns={columns}
              columnOrder={orderColumns}
              bills={billsToRender}
              payBills={handlePayBill}
              genericError={genericError}
            />
          </>
        ) : (
          <>
            {loaded ? (
              <NoResult text={t("bills.result.no-result")}/>
            ) : (
              ""
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PayBillsPage;
